/*
 * Authors: mariushirjanu
 * Created: 12/04/2018
 * Created: 02/03/2023
 */
import { ICatalogCartItem } from './price-cart.service';
import { Injectable } from '@angular/core';
import { DialogSize, GaMessageService, IDialog } from '../../../shared/message/ga-message.service';
import { GaDeferredService, IGADeferred } from '../../../shared/services/ga-deferred.service';
import { IPartConfigurationOption } from './part-configurator-data.service';
import { IPartConfiguratorModel, PartConfiguratorDialogComponent } from './part-configurator-dialog.component';

@Injectable()
export class PartConfiguratorService {
  private partConfigurationDialog:IDialog;

  constructor(
    private deferredService:GaDeferredService,
    private messageService:GaMessageService
  ) {
    /***/
  }

  // select parts if available
  public selectPart(product:ICatalogCartItem, quantity:number):Promise<string | void> {
    const deferred:IGADeferred<string | void> = this.deferredService.defer();

    // ignore the part configurator when: 1) the product doesn't have part configuration, 2) the product is removed from the cart
    if (!product.partConfigurationExist || quantity === 0) {
      return Promise.resolve();
    }

    this.partConfigurationDialog = this.messageService.showDialog({
      component: PartConfiguratorDialogComponent,
      wrapperComponent: false,
      inputs: {
        title: 'CATALOG.PART_CONFIGURATION_DIALOG.TITLE',
        product
      },
      outputs: {
        onSave: (model:IPartConfiguratorModel) => {
          const keyboardLayout:IPartConfigurationOption = model.moreOptions || model.partConfiguration;
          product.partSuffix = keyboardLayout.productCategorySuffix;
          product.partSuffixDescription = keyboardLayout.description;
          deferred.resolve();
          this.closeDialog();
        },
        onCancel: () => {
          deferred.reject();
          this.closeDialog();
        }
      },
      size: DialogSize.MD
    });

    return deferred.promise;
  }

  private closeDialog():void {
    this.partConfigurationDialog.hide();
  }
}